import { Link } from 'react-router-dom';
import ReaddyForm, { type FormField } from '@/components/feature/ReaddyForm';
import SectionHeading from '@/components/base/SectionHeading';

const inquiryFields: FormField[] = [
  {
    name: 'name',
    label: '称呼',
    type: 'text',
    required: true,
    placeholder: '请填写我们如何称呼你',
    half: true,
    maxLength: 40,
  },
  {
    name: 'email',
    label: '联系邮箱',
    type: 'email',
    required: true,
    placeholder: '用于接收回复',
    half: true,
  },
  {
    name: 'subject',
    label: '咨询类型',
    type: 'select',
    required: true,
    options: ['一般咨询', '媒体采访邀约', '内容更正与纠错', '官方账号核实', '隐私与侵权投诉', '其他'],
  },
  {
    name: 'message',
    label: '咨询内容',
    type: 'textarea',
    required: true,
    placeholder: '请简单说明你的问题或诉求，若为内容更正请附上文章标题与链接。',
    hint: '最多 500 字。我们不会要求你提供与咨询无关的个人信息。',
  },
];

const notes = [
  { icon: 'ri-time-line', label: '回复时效', value: '一般咨询 3 个工作日内回复' },
  { icon: 'ri-user-voice-line', label: '采访邀约', value: '请注明媒体名称、栏目与选题方向' },
  { icon: 'ri-file-forbid-line', label: '内容更正', value: '请附文章链接与更正依据' },
];

export default function InquirySection() {
  return (
    <section id="inquiry" className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="bg-background-100 border border-foreground-950/10 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                联系咨询表单
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                适用于采访邀约、内容更正、账号核实与日常咨询，不适合提交敏感线索。
              </p>
              <div className="mt-6">
                <ReaddyForm
                  formId="contact-inquiry-form"
                  submitAddr="https://readdy.ai/api/form/dah87kboh653ivfvno00"
                  fields={inquiryFields}
                  honeypotName="website_alt"
                  submitLabel="发送咨询"
                  successText="你的咨询已送达，我们会在 3 个工作日内回复到你留下的邮箱。"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 order-1 lg:order-2">
            <SectionHeading
              kicker="General Inquiry"
              title="一般咨询与媒体沟通"
              description="如果你的问题不涉及需要保密的一手材料，用这个表单会更快。留下常用邮箱即可，我们只把它用于回复。"
            />

            <dl className="mt-8 space-y-5">
              {notes.map((note) => (
                <div
                  key={note.label}
                  className="flex items-start gap-4 pb-5 border-b border-foreground-950/10 last:border-b-0"
                >
                  <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-900">
                    <i className={`${note.icon} text-lg`}></i>
                  </span>
                  <div>
                    <dt className="font-mono text-xs tracking-[0.14em] uppercase text-foreground-500">
                      {note.label}
                    </dt>
                    <dd className="mt-1.5 text-sm leading-relaxed text-foreground-800">
                      {note.value}
                    </dd>
                  </div>
                </div>
              ))}
            </dl>

            <p className="mt-7 text-sm leading-relaxed text-foreground-600">
              需要授权转载或联合调查？请直接前往
              <Link
                to="/cooperation"
                className="text-primary-600 hover:text-primary-700 underline underline-offset-4 mx-1"
              >
                商务合作
              </Link>
              提交申请，处理速度更快。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}